
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/broking",
      function () {
        return require("private-next-pages/broking/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/broking"])
      });
    }
  